<template>
	<div>
		<!-- 共享打印 -->
		<div class="noticesBlockSty transition03 " :class="isPrintShow && countdown > 0 ? '' : 'transitionDelay03'">
			<div>
				<img :src="initThemeImg(theme, 'icon_gxdy_tips@2x')" alt="" class="imgWH12">
				<div class="flex1">
					账号&nbsp;&nbsp;15073773333&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;密码&nbsp;&nbsp;nihaonihao1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;提示：凭以上信息可连接打印机。
				</div>
			</div>

			<div class="displayF16Center cursorColor">
				<div @click.stop="jumpLinkHandle()" class="cursor">跳转</div>
				<div @click.stop="clearInterValMethods(true)" class="cursor">知道了（{{countdown}}S）</div>
			</div>
			<!-- <img @click="closeHandle()" :src="initThemeImg(theme, 'icon-x-8@2x')" alt="" class="imgWH8 cursor"> -->
		</div>

		<!-- 公告 -->
		<div class="noticesBlockSty transition03 "
			:class="publicityContent && !isPrintShow && countdown > 0 ? '' : 'transitionDelay03'">
			<div>
				<img :src="initThemeImg(theme, 'icon-notices-h@2x')" alt="" class="imgWH12">
				<div class="flex1">
					【公示】<span v-html="publicityContent"></span>
				</div>
			</div>

			<div class="displayF16Center cursorColor">
				<div @click.stop="clearInterValMethods(true)" class="cursor">知道了（{{countdown}}S）</div>
				<div @click="closeHandle()" class="cursor">不再提醒</div>
			</div>
			<!-- <img @click="closeHandle()" :src="initThemeImg(theme, 'icon-x-8@2x')" alt="" class="imgWH8 cursor"> -->
		</div>
	</div>
</template>

<script setup>
	import {
		initThemeImg,
		jumpUrlConfig,
		setMessageQueue
	} from '@/utils/common'
	import {
		sysnoticepublicityswitchSave,
		sysnoticepublicityGetPublicityByUrl
	} from '@/api/systemNotification'
	import useUserStore from '@/store/modules/user'
	import {
		watch
	} from 'vue'

	const {
		proxy
	} = getCurrentInstance()
	const props = defineProps({
		propsBackUrlObj: {
			type: Object,
			default: () => {}
		}
	})

	const route = useRoute()
	const router = useRouter()

	// 主题色--默认亮色
	const theme = computed(() => {
		return useUserStore().theme
	})
	// 获取自定义配置
	const userConfigData = computed(() => {
		return useUserStore().userConfigData
	})
	// 倒计时
	const countdown = computed(() => {
		return useUserStore().countdown
	})
	// 共享打印状态
	const isPrintShow = computed(() => {
		return useUserStore().isPrintShow
	})

	const publicityId = ref('') // 公示id
	const publicityContent = ref('') // 公示内容

	// 监听倒计时 并清除倒计时
	watch(countdown, val => {
		if (val <= 0) {
			// 清除倒计时
			clearInterValMethods(true)
		}
		// console.log(val, route.path, 'watch countdown')
	})
	
	// 监听 共享打印状态
	watch(isPrintShow, val => {
		if (val) {
			// 清除倒计时
			clearInterValMethods()
			// 倒计时
			countdownMethods()
		}
		// console.log(useUserStore().countdown, route.path, 'useUserStore().countdown')
	})

	// 切换页面/路由 清除定时
	watch(router.currentRoute, (newVal, old) => {
		console.log(newVal, old, 'newVal, old watch')
		if (newVal.path !== old.path) {
			// 清除倒计时
			clearInterValMethods(true)
		}
	})
	// , {
	// 	deep: true,
	// 	immediate: true
	// }

	// 跳转
	function jumpLinkHandle() {
		window.open('https://www.xiaomiprint.com')
	}

	// 获取公示内容（根据路由路径）
	function sysnoticepublicityGetPublicityByUrlApi() {
		sysnoticepublicityGetPublicityByUrl({
			menuUrl: '/' + props.propsBackUrlObj.parUrl
		}).then(res => {
			if (res) {
				let data = res.data
				if (data) {
					publicityId.value = data.id

					if (data.content) {
						publicityContent.value = resetHtmlData(data.content)

						setTimeout(() => {
							// 选择所有当前具有该类的元素
							const elements = document.querySelectorAll('.at-button');
							console.log(elements, 'elements')
							// 为每个元素添加公示点击事件监听器
							elements.forEach(element => {
								element.addEventListener('click', publicityContentHandler, false);
							});
						})
					} else {
						publicityContent.value = ''
					}
				} else {
					publicityContent.value = ''
				}
				if (publicityContent.value) {
					// 初始化公告时 共享打印弹窗关闭
					useUserStore().isPrintShow = false
					// 清除倒计时
					clearInterValMethods(true)
					useUserStore().countdown = 9
					// 倒计时
					countdownMethods()
				}

				// 暂时注释 不需要变化页面内容高度
				// proxy.$emit('isHavePublicityContent', publicityContent.value ? true : false)
			}
		}).catch(e => {
			setMessageQueue('error', e)
			console.log(e)
		})
	}

	// 清除倒计时
	function clearInterValMethods(type) {
		if (useUserStore().setIntervalTime) {
			clearInterval(useUserStore().setIntervalTime)
			useUserStore().setIntervalTime = null
		}

		if (type) {
			useUserStore().countdown = 0

			if (useUserStore().isPrintShow) {
				useUserStore().isPrintShow = false
			}
		}
	}

	// 倒计时
	function countdownMethods() {
		useUserStore().setIntervalTime = setInterval(() => {
			useUserStore().countdown--

			if (useUserStore().countdown <= 0) {
				// 清除倒计时
				clearInterValMethods(true)
			}
		}, 1000)
	}

	// 重置html数据 去掉#
	function resetHtmlData(htmlString) {
		// 创建一个临时的div元素
		const tempDiv = document.createElement('div');
		tempDiv.innerHTML = htmlString; // 设置HTML字符串

		// 获取所有子节点
		const children = Array.from(tempDiv.childNodes);

		// 遍历所有子节点
		children.forEach(child => {
			if (child.style) {
				// 获取所有子节点
				let childLabel = Array.from(child.childNodes);
				childLabel.forEach(item => {
					if (item.className) {
						item.innerHTML = item.innerHTML.replace(/#/g, '')
						console.log(item.innerHTML, 'item')
					}
				})
			}
		});

		return tempDiv.innerHTML;
	}

	// 点击关闭公示
	function closeHandle() {
		sysnoticepublicityswitchSave({
			publicityId: publicityId.value
		}).then(res => {
			if (res) {
				// 获取公示内容（根据路由路径）
				sysnoticepublicityGetPublicityByUrlApi()
			}
		}).catch(e => {
			setMessageQueue('error', e)
			console.log(e)
		})
	}

	// 监听公示点击事件
	function publicityContentHandler(e) {
		let url = e.srcElement.dataset.data
		let obj = props.propsBackUrlObj
		console.log(url && url !== 'null', 'at-button')
		// url不带参数时 需要加 obj.str = '?'来占位
		if (url && url !== 'null') {
			let readModel = userConfigData.value.readModel

			if (readModel === 'newPage') {
				jumpUrlConfig(url, obj.parUrl, '?')
			} else {
				router.push(url)
			}

			// jumpUrlConfig(url, obj.url, obj.str)
		} else {
			setMessageQueue('info', '页面待开发，二期计划')
		}
	}

	const time = ref(null)
	onMounted(() => {
		if (props.propsBackUrlObj && props.propsBackUrlObj.parUrl) {
			// 待添加有token后可调用
			if (localStorage.getItem('token')) {
				// 获取公示内容（根据路由路径）
				sysnoticepublicityGetPublicityByUrlApi()
			} else {
				time.value = setInterval(() => {
					if (localStorage.getItem('token')) {
						clearInterval(time.value)
						time.value = null
						// 获取公示内容（根据路由路径）
						sysnoticepublicityGetPublicityByUrlApi()
					}
				}, 100)
			}
		}
	})

	onBeforeUnmount(() => {
		// 选择所有当前具有该类的元素
		const elements = document.querySelectorAll('.at-button');
		if (elements && elements.length > 0) {
			// 为每个元素删除公示点击事件监听器
			elements.forEach(element => {
				element.removeEventListener('click', publicityContentHandler, false);
			});
		}

		clearInterval(time.value)
		time.value = null
		// 清除倒计时
		clearInterValMethods(true)
	})
</script>

<style lang="scss" scoped>
	@import "@/styles/handle.scss";

	.noticesBlockSty {
		border-radius: 2px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		column-gap: 12px;
		padding: 0 16px;
		box-sizing: border-box;
		margin-bottom: 16px;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		height: 40px;
		font-size: 14px;
		width: calc(100% - 48px);
		position: fixed;
		left: 24px;
		top: 68px;
		z-index: 998; // 20260327 优化 层级关系 101 => 999
		@include border('el-button--primary_border');
		@include background('common_notices_back');

		>div:first-child {
			display: flex;
			align-items: center;
			column-gap: 8px;
			flex: 1;

			>div {
				text-overflow: ellipsis;
				overflow: hidden;
				white-space: nowrap;
				width: calc(100% - 180px);
				@include color('color_FFF');

				// span {
				// 	@include color('cursor_color');
				// }
			}
		}
	}
</style>